import { StyleProps } from '@bonusly/design-system';

export const getStyle = (isSelected?: boolean): StyleProps => ({
	alignItems: 'center',
	borderBottomColor: 'rgba(0, 0, 0, 0)',
	borderBottomWidth: '4px',
	color: 'gray.500',
	display: 'flex',
	fontSize: 'md',
	fontWeight: 'medium',
	pb: 2.5,
	pt: 3.5,
	px: 3,
	...(isSelected && {
		color: 'blue.600',
		borderBottomColor: 'blue.600',
	}),
});
